import React from "react";

export const TreeViewDivider = () => null;
